import { useEffect, useRef, useState, ReactNode } from "react";
import dayjs, { Dayjs } from "dayjs";

import { Box, Grid, Stack, Typography, Button, TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PersonAddDisabledIcon from "@mui/icons-material/PersonAddDisabled";
import { HttpMainApi } from "../../interface/main-api";
import { userState } from "../../interface/MainInterface";
import { getFormattedDateTime } from "../../utils/getFormattedDateTime";
import LoadingCircle from "../../utils/LoadingCircle";
import Toast from "../../utils/Toast";
import * as XLSX from "xlsx";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import CryptoJS from "crypto-js";
interface propsType {
  userState: userState;
}
const mainApi = new HttpMainApi();

const UserFingerList = (props: propsType) => {
  const toastRef: any = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [userList, setUserList] = useState<any>([]);
  const [userName, setUserName] = useState("");
  const [fromDate, setFromDate] = useState<Dayjs | null>(
    dayjs().add(-365, "day")
  );
  const [toDate, setToDate] = useState<Dayjs | null>(dayjs());

  useEffect(() => {
    return () => {
      setIsLoading(false);
      setUserList([]);
      setFromDate(null);
      setToDate(null);
    };
  }, []);

  const get_user_finger_list = async () => {
    setIsLoading(true);
    setUserList([]);
    const pk = "COMMUNITY/USER";
    const sk = userName;
    const param: any = {
      pk: pk,
      sk: sk,
      selectLevel: selectLevel,
    };

    const res = await mainApi.get_user_finger_list(param);
    if (res.code === "200") {
      setUserList(res.response.result);
    } else if (res.code === "400") {
    } else {
      alert(
        `알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`
      );
    }
    setIsLoading(false);
  };

  const renderFingerButton = (params: any) => (
    <Button
      color="primary"
      onClick={() =>
        handrFingerButton(
          params.row.pk,
          params.row.sk,
          params.row.fingerState,
          params.row.fingerInputDt
        )
      }
    >
      <FingerprintIcon />
    </Button>
  );

  const handrFingerButton = async (
    pk: string,
    sk: string,
    fingerState: string,
    fingerInputDt: string
  ) => {
    const { formattedDateTime } = getFormattedDateTime();
    let StateMemo = "";
    let deleteDt = "";
    if (fingerState === "등록") {
      StateMemo = "지문 [사용안함] 상태로 업데이트 하시겠습니까?";
      fingerState = "";
      fingerInputDt = fingerInputDt;
      deleteDt = formattedDateTime;
    } else {
      StateMemo = "지문 [등록] 상태로 업데이트 하시겠습니까?";
      fingerState = "등록";
      fingerInputDt = formattedDateTime;
      deleteDt = "";
    }

    const confirmCancel = window.confirm(sk + StateMemo);
    if (confirmCancel) {
      const param: any = {
        pk: pk,
        sk: sk,
        fingerState: fingerState,
        fingerInputDt: fingerInputDt,
        fingerDeleteDt: deleteDt,
      };

      const res = await mainApi.update_user_finger(param);
      if (res.code === "200") {
        alert("지문 정보가 수정 되었습니다.");
        get_user_finger_list();
      } else if (res.code === "400") {
        alert(
          "지문 정보 업데이트에 실패하였습니다.\n다시 조회 후 진행해주세요."
        );
      } else {
        alert(
          `알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`
        );
      }
    }
  };

  // const renderCoummnityInfo = async (params: GridRenderCellParams<any, any>): Promise<ReactNode> => {

  //   const { formatpk } = getFormattedDateTime();
  //   const userId = props.userState.userId;
  //   const pk = userId;
  //   const sk = formatpk;
  //   const param: any = {
  //     pk: pk,
  //     sk: sk,
  //   };
  //   const res = await mainApi.get_user_finger_community_info(param);
  //   if (res.code == "200") {
  //     return <div>{params.row.userId}</div>;
  //   } else {
  //     return <div>{params.row.userId}</div>;
  //   }
  // };

  const padFourDigits = (value: number) => {
    const paddedValue = String(value).padStart(4, "0"); // 4자리로 만들고 앞에 0을 채웁니다.
    return paddedValue;
  };

  const columns: GridColDef[] = [
    {
      field: "userId",
      headerName: "회원 아이디",
      width: 110,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "userName",
      headerName: "회원 이름",
      width: 150,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "combinedValue",
      headerName: "동/호",
      width: 150,

      align: "center",
      headerAlign: "center",
      valueGetter: (params) =>
        `${params.row.userDong}동 ${padFourDigits(params.row.userHo)}호`,
    },
    {
      field: "fingerState",
      headerName: "지문 상태",
      width: 110,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "fingerUpdate",
      headerName: "상태 변경",
      width: 110,
      editable: false,
      renderCell: renderFingerButton,
      align: "center",
      headerAlign: "center",
    },
    // {
    //   field: "coummnityInfo",
    //   headerName: "가입 정보",
    //   width: 200,
    //   renderCell: renderCoummnityInfo,
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      field: "fingerInputDt",
      headerName: "지문 등록일",
      type: "number",
      width: 200,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "fingerDeleteDt",
      headerName: "지문 삭제일",
      type: "number",
      width: 200,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
  ];

  const [selectLevel, setSelectLevel] = useState("등록");
  const handleLevelChange = (event: SelectChangeEvent) => {
    setSelectLevel(event.target.value as string);
  };

  const downloadExcel = (accountList: any[], columns: any[]) => {
    // 각 행에 대해 엑셀 파일에 포함될 값을 계산
    const dataForExcel = accountList.map((row) => {
      let newRow: { [key: string]: any } = {};
      columns.forEach((col) => {
        // valueGetter가 정의된 경우 해당 로직을 사용하여 값을 계산
        if (col.valueGetter) {
          newRow[col.headerName] = col.valueGetter({ row });
        } else {
          newRow[col.headerName] = row[col.field];
        }
      });
      return newRow;
    });

    // 여기서부터는 이전 예시와 동일하게 xlsx 라이브러리를 사용하여 엑셀 파일 생성
    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Accounts");
    XLSX.writeFile(workbook, "accounts.xlsx");
  };
  return (
    <>
      <Stack
        direction={"column"}
        spacing={2}
        sx={{ p: "32px", pb: "16px !important" }}
      >
        <Box sx={{ position: "absolute", top: "60px", right: "20px" }}>
          <Stack direction="row" spacing={2} alignItems="flex-end">
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">상태</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectLevel}
                  label="상태"
                  onChange={handleLevelChange}
                  sx={{ height: 46 }}
                >
                  <MenuItem value={"전체"}>전체</MenuItem>
                  <MenuItem value={"등록"}>등록</MenuItem>
                  <MenuItem value={"미등록"}>미등록</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <TextField
              id="userId"
              value={userName}
              placeholder="이름"
              variant="outlined"
              label="이름"
              autoFocus
              fullWidth
              // required
              type="text"
              autoComplete="off"
              inputProps={{
                enterKeyHint: "Enter",
                style: { padding: "12px 16px 10px 16px" },
              }}
              onChange={(e) => {
                setUserName(e.target.value);
              }}
              sx={{ marginTop: "9px !important" }}
            />
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => {
                get_user_finger_list();
              }}
              sx={{
                borderRadius: "4px",
                width: "54px",
                height: "54px",
                marginTop: "9px !important",
              }}
            >
              <SearchIcon />
            </Button>
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => downloadExcel(userList, columns)}
              sx={{
                borderRadius: "4px",
                width: "94px",
                height: "54px",
                marginTop: "9px !important",
              }}
            >
              <FileDownloadIcon />
            </Button>
          </Stack>
        </Box>
        <Box className="sub-header-root" sx={{ marginBottom: 4 }}>
          <Typography variant="h5" gutterBottom className="sub-header-title">
            지문 관리
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid>
            <DataGrid
              rows={userList}
              columns={columns}
              disableRowSelectionOnClick
              style={{ height: 500 }}
              getRowId={(row) => (row.userId ? row.userId.toString() : "")}
            />
            {userList.map((userList: any, index: number) => (
              <Grid
                key={`pressCard-${index}`}
                item
                xs={12}
                sm={12}
                md={6}
                lg={4}
                xl={3}
              ></Grid>
            ))}
          </Grid>
        </Box>
      </Stack>
      <Toast ref={toastRef} />
      <LoadingCircle loading={isLoading} />
    </>
  );
};

export default UserFingerList;
